// extracted by css-extract-rspack-plugin
export default {"info-cards":"InfoCards_info-cards__E-Wve"};